import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import TouchAppIcon from "@mui/icons-material/TouchApp";
import { ClickActionEvent } from '../../util/analytics'


import projects from "./Data"
import LoadingImage from '../LoadingImage';
 



const sxHeroContent = { py: 8 };
const sxCardGrid = { pt: 8, pb: 8 };
const sxCard = { height: '100%', display: 'flex', flexDirection: 'column' };
const sxCardHover = { ...sxCard, boxShadow: '0 4px 8px 0 rgba(0,0,255,0.8), 0 6px 20px 0 rgba(0,0,255,0.8)', cursor: 'pointer', opacity: 0.7, transition: '0.2s linear' };
const sxCardMedia = { paddingTop: '22.25%', height: 70 };
const sxCardContent = { flexGrow: 1 };

export default function Articles() {
  const [selectedProject, setSelectedProject] = React.useState('')

  const MouseOver = (t)  =>{
    setSelectedProject(t)
  }

  const MouseOut = (event)  =>{
    setSelectedProject('')
  }

  return (
    <React.Fragment >
      <div style={{backgroundColor:"#bcf2f1"}}>
        <Box sx={{ ...sxHeroContent, backgroundColor: '#bcf2f1' }}>
          <Container maxWidth="sm">
            <Typography component="h1" variant="h3" align="center" color="textPrimary" gutterBottom>
              My Medium Articles ✍️
            </Typography>
            <Typography variant="h6" align="center" color="textSecondary" paragraph>
              These are some technical articles based on my professional and personal experiences.
            </Typography>
          </Container>
        </Box>
        <Container sx={sxCardGrid} maxWidth="md">
          <Grid container spacing={4}>
            {projects.map((project) => (
              <Grid item key={project.id} xs={12} sm={6} md={4} >
               <Link href={project.deployedLink} target="_blank" rel="noreferrer noopener" onClick={()=>{ClickActionEvent('MediumArticle '+project.name, 'articles section', 'medium articles clicked')}} > 
                <Card style={{backgroundColor:"#0ABAB5"}}  sx={project.name===selectedProject?sxCardHover:sxCard}  onMouseOver={()=>MouseOver(project.name)} onMouseOut={MouseOut}>
                  <LoadingImage sx={sxCardMedia} src={process.env.PUBLIC_URL + project.image} alt={project.name} />
                  <CardContent sx={sxCardContent}>
                    <Typography gutterBottom variant="h5" component="h2">
                      {project.name} <TouchAppIcon/>
                    </Typography>
                    <Typography>
                      {project.description}
                    </Typography>
                  </CardContent>
                </Card>
                </Link>
              </Grid>
            ))}
          </Grid>
        </Container>
      </div>
    </React.Fragment>
  );
}
